import type { Editor } from '@tiptap/react'

import type { EditorVariant } from '../markdown-editor.interface'
import { getMarkdownFromEditor } from '../utils/markdown.util'

export interface KeyHandlerConfig {
  editor: Editor | null
  variant: EditorVariant
  onSubmit?: (markdown: string) => void
}

/**
 * Creates a key handler function for the TipTap editor
 */
export const createKeyHandler =
  ({ editor, variant, onSubmit }: KeyHandlerConfig) =>
  (_view: unknown, event: KeyboardEvent): boolean => {
    if (variant === 'chat' && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      const markdown = getMarkdownFromEditor(editor)
      onSubmit?.(markdown)
      return true
    }

    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault()
      const markdown = getMarkdownFromEditor(editor)
      onSubmit?.(markdown)
      return true
    }

    return false
  }
